<form [formGroup]="stripeForm" #card>
  <div class="card-details-block mb-3">
    <div class="card-name-area clearfix">
      <div class="card-name float-left">Credit Card</div>
      <div class="card-type float-right"><i class="card-box" ngClass="{{cardType}}"></i></div>
    </div>
    <div class="card-holder-name">
      <input class="form-control style-underline" type="text" placeholder="Name on the card"
             formControlName="name" name="stripe-name">
      <app-alert *ngIf="!stripeForm.controls['name'].valid && stripeForm.controls['name'].touched"
                 class="stripe-num-error" [dismissible]="false" [type]="'warning'" [value]="stripeNumError"></app-alert>
    </div>
    <div class="card-number">
      <div #stripeCardNumber class="form-control style-underline"></div>
      <app-alert class="stripe-num-error" [dismissible]="false" [type]="'warning'" [value]="stripeNumError"></app-alert>
    </div>
    <div class="card-additional">
      <div class="detail-group clearfix">
        <div class="expiry float-left">
          <label class="col-form-label" data-tid="elements_examples.form.card_expiry_label">Exp:</label>
          <div #stripeCardExpiry class="form-control style-underline"></div>
        </div>
        <div class="cvv float-right">
          <label class="col-form-label" data-tid="elements_examples.form.card_cvc_label">CVV:</label>
          <div #stripeCardCvc class="form-control style-underline" id="stripeCardCvc"></div>
        </div>
      </div>
      <app-alert class="stripe-num-error" [dismissible]="false" [type]="'warning'" [value]="stripeExpError"></app-alert>
    </div>
  </div>
  <div *ngIf="showButtons">
    <button class="btn btn-primary text-uppercase" (click)="saveNewCard()" [disabled]="!stripeForm.valid" id="btnSave">Save</button>
    <button type="button" class="btn btn-secondary text-uppercase" (click)="cancelAddNewCard()" id="btnCancel">Cancel</button>
  </div>
</form>
